<template>
  <div>
    <v-select
      :items="userAnatomicalRegions"
      v-model="selectedRegion"
      item-text="title"
      item-value="id"
      :hint="selectedRegion ? '' : 'Por favor escolha uma região anatómica'"
      persistent-hint
    >
    </v-select>
    <table
      :style="cssVars"
      :class="style.borders ? 'bordered' : ''"
      class="combined-report styled-table selectable"
    >
      <thead>
        <tr>
          <th class="header-title">
            <span class="" v-text="'Patologia Tumoral'"></span>
          </th>
          <th
            class="header-title"
            v-for="hematologyOrgan in hematologyOrgans"
            :key="hematologyOrgan"
          >
            {{ hematologyOrgan }}
          </th>
          <th class="header-title">Total</th>
        </tr>
      </thead>
      <template v-for="(category, cIndex) in tableTumoralValues.children">
        <tr class="categ-title" :key="cIndex">
          <td class="pl-3">{{ category.title }}</td>
          <td
            v-for="hematologyOrgan in hematologyOrgans"
            :key="hematologyOrgan"
          ></td>
          <td></td>
        </tr>

        <tr
          class="subcateg-title"
          :key="oIndex + cIndex"
          v-for="(diagnosis, oIndex) in category.items"
        >
          <td class="pl-5">
            <span class="pl-5">{{ diagnosis }}</span>
          </td>

          <td
            v-for="hematologyOrgan in hematologyOrgans"
            :key="hematologyOrgan"
          >
            {{
              category.hematologyCounters
                ? category.hematologyCounters[hematologyOrgan]
                : ''
            }}
          </td>

          <td>{{ category.count }}</td>
        </tr>

        <template v-for="(type, tIndex) in category.children">
          <tr class="categ-title" :key="cIndex + tIndex">
            <td class="pl-5">{{ type.title }}</td>
            <td
              v-for="hematologyOrgan in hematologyOrgans"
              :key="hematologyOrgan"
            ></td>
            <td></td>
          </tr>

          <tr
            class="subcateg-title"
            :key="cIndex + tIndex + dIndex"
            v-for="(diagnosis, dIndex) in type.items"
          >
            <td class="pl-5">
              <span class="pl-5">{{ diagnosis }}</span>
            </td>
            <td
              v-for="hematologyOrgan in hematologyOrgans"
              :key="hematologyOrgan"
            >
              {{
                type.hematologyCounters
                  ? type.hematologyCounters[hematologyOrgan]
                  : ''
              }}
            </td>
            <td>{{ type.count }}</td>
          </tr>

          <template v-for="(subtype, sIndex) in type.children">
            <tr class="categ-title" :key="cIndex + tIndex + sIndex">
              <td class="pl-5">
                <span class="pl-4">{{ subtype.title }}</span>
              </td>
              <td
                v-for="hematologyOrgan in hematologyOrgans"
                :key="hematologyOrgan"
              ></td>
              <td></td>
            </tr>

            <tr
              class="subcateg-title"
              :key="cIndex + tIndex + sIndex + dIndex"
              v-for="(diagnosis, dIndex) in subtype.items"
            >
              <td class="pl-5">
                <span class="pl-5">{{ diagnosis }}</span>
              </td>
              <td
                v-for="hematologyOrgan in hematologyOrgans"
                :key="hematologyOrgan"
              >
                {{
                  subtype.hematologyCounters
                    ? subtype.hematologyCounters[hematologyOrgan]
                    : ''
                }}
              </td>
              <td>{{ subtype.count }}</td>
            </tr>
          </template>
        </template>
      </template>
      <tr v-if="selectedRegion" class="categ-title">
        <td>Total</td>
        <td
          v-for="hematologyOrgan in hematologyOrgans"
          :key="hematologyOrgan"
        ></td>
        <td>{{ tableTumoralValues.total }}</td>
      </tr>
    </table>
    <div class="mt-4"></div>
    <table
      v-if="user.specialty !== 'oncology'"
      :style="cssVars"
      :class="style.borders ? 'bordered' : ''"
      class="combined-report styled-table selectable"
    >
      <thead>
        <tr>
          <th class="header-title">
            <span class="" v-text="'Patologia Adicional'"></span>
          </th>
          <th class="header-title">Total</th>
        </tr>
      </thead>
      <template v-for="(category, cIndex) in tableAdicionalValues.children">
        <tr class="categ-title" :key="cIndex">
          <td class="pl-3">{{ category.title }}</td>
          <td></td>
        </tr>

        <tr
          class="subcateg-title"
          :key="oIndex + cIndex"
          v-for="(diagnosis, oIndex) in category.items"
        >
          <td class="pl-5">
            <span class="pl-5">{{ diagnosis }}</span>
          </td>
          <td>{{ category.count }}</td>
        </tr>

        <template v-for="(type, tIndex) in category.children">
          <tr class="categ-title" :key="cIndex + tIndex">
            <td class="pl-5">{{ type.title }}</td>
            <td></td>
          </tr>

          <tr
            class="subcateg-title"
            :key="cIndex + tIndex + dIndex"
            v-for="(diagnosis, dIndex) in type.items"
          >
            <td class="pl-5">
              <span class="pl-5">{{ diagnosis }}</span>
            </td>
            <td>{{ type.count }}</td>
          </tr>

          <template v-for="(subtype, sIndex) in type.children">
            <tr class="categ-title" :key="cIndex + tIndex + sIndex">
              <td class="pl-5">
                <span class="pl-4">{{ subtype.title }}</span>
              </td>
              <td></td>
            </tr>

            <tr
              class="subcateg-title"
              :key="cIndex + tIndex + sIndex + dIndex"
              v-for="(diagnosis, dIndex) in subtype.items"
            >
              <td class="pl-5">
                <span class="pl-5">{{ diagnosis }}</span>
              </td>
              <td>{{ subtype.count }}</td>
            </tr>
          </template>
        </template>
      </template>
      <tr v-if="selectedRegion" class="categ-title">
        <td>Total</td>
        <td>{{ tableAdicionalValues.total }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import helpers from '../mixins/statsHelperFunc'
import { mapGetters } from 'vuex'
export default {
  props: {
    logs: { default: [] },
    logbookType: String
  },
  mixins: [helpers],
  data() {
    return {
      style: {
        borders: true,
        borderColor: '#cccccc',
        colors: ['#ffffff']
      },
      selectedRegion: null
    }
  },
  computed: {
    ...mapGetters(['user']),
    hematologyOrgans() {
      return this.selectedRegion === 'Tecidos-Hematopoiéticos-e-Linfóides'
        ? [
            ...new Set(
              this.logs
                .map(l => l['pathology-diagnosis'].hematologyOrgan)
                .filter(ho => ho)
            )
          ]
        : []
    },
    userAnatomicalRegions() {
      let values = []
      const ids = Object.keys(this.groupItems())
      const groupItems = this.groupItems()
      ids.forEach(item => {
        values.push({
          id: item,
          title: groupItems[item].title
        })
      })
      return values
    },
    tableTumoralValues() {
      let items = JSON.parse(JSON.stringify(this.groupItems(true)))
      let total = 0
      this.logs.forEach(log => {
        if (
          log['pathology-diagnosis'] &&
          log['pathology-diagnosis'].tumoral === true
        ) {
          let group = log['pathology-diagnosis'].group
          let category = log['pathology-diagnosis'].category
          let type = log['pathology-diagnosis'].type
          let subtype = log['pathology-diagnosis'].subtype

          group = group ? group.replace(/[, ]+/g, '-').trim() : null
          category = category ? category.replace(/[, ]+/g, '-').trim() : null
          type = type ? type.replace(/[, ]+/g, '-').trim() : null
          subtype = subtype ? subtype.replace(/[, ]+/g, '-').trim() : null

          group
            ? (items[group] = this.addAndCount(items[group], log, !!category))
            : ''
          category
            ? (items[group].children[category] = this.addAndCount(
                items[group].children[category],
                log,
                !!type
              ))
            : ''
          type
            ? (items[group].children[category].children[type] =
                this.addAndCount(
                  items[group].children[category].children[type],
                  log,
                  !!subtype
                ))
            : ''
          subtype
            ? (items[group].children[category].children[type].children[
                subtype
              ] = this.addAndCount(
                items[group].children[category].children[type].children[
                  subtype
                ],
                log,
                false
              ))
            : ''

          if (group === this.selectedRegion) {
            !!log['quantidade']
              ? (total = total + Math.round(log['quantidade']))
              : (total = total + 1)
          }
        }
      })
      if (this.selectedRegion && items[this.selectedRegion]) {
        items[this.selectedRegion].total = total
        return items[this.selectedRegion]
      }
      return items
    },
    tableAdicionalValues() {
      let items = JSON.parse(JSON.stringify(this.groupItems(false)))
      let total = 0
      this.logs.forEach(log => {
        if (
          log['pathology-diagnosis'] &&
          log['pathology-diagnosis'].tumoral === false
        ) {
          let group = log['pathology-diagnosis'].group
          let category = log['pathology-diagnosis'].category
          let type = log['pathology-diagnosis'].type
          let subtype = log['pathology-diagnosis'].subtype

          group = group ? group.replace(/[, ]+/g, '-').trim() : null
          category = category ? category.replace(/[, ]+/g, '-').trim() : null
          type = type ? type.replace(/[, ]+/g, '-').trim() : null
          subtype = subtype ? subtype.replace(/[, ]+/g, '-').trim() : null

          group
            ? (items[group] = this.addAndCount(items[group], log, !!category))
            : ''
          category
            ? (items[group].children[category] = this.addAndCount(
                items[group].children[category],
                log,
                !!type
              ))
            : ''
          type
            ? (items[group].children[category].children[type] =
                this.addAndCount(
                  items[group].children[category].children[type],
                  log,
                  !!subtype
                ))
            : ''
          subtype
            ? (items[group].children[category].children[type].children[
                subtype
              ] = this.addAndCount(
                items[group].children[category].children[type].children[
                  subtype
                ],
                log,
                false
              ))
            : ''
          if (group === this.selectedRegion) {
            !!log['quantidade']
              ? (total = total + Math.round(log['quantidade']))
              : (total = total + 1)
          }
        }
      })
      if (this.selectedRegion && items[this.selectedRegion]) {
        items[this.selectedRegion].total = total
        return items[this.selectedRegion]
      }
      return items
    },
    total() {
      const total = this.logs.filter(
        log =>
          log['pathology-diagnosis'] &&
          log['pathology-diagnosis'].group.replace(/[, ]+/g, '-').trim() ===
            this.selectedRegion
      )
      return total.length
    },
    cssVars() {
      return {
        '--bg-color': this.style.colors[0],
        '--bg-light-color': this.style.colors[0] + 20,
        '--bg-odd-color': this.style.colors[0] + 40,
        '--categ-color': this.style.colors[0] + 99,
        '--subcateg-color': this.style.colors[0] + 60,
        '--border-collapse': this.style.borders ? 'collapse' : 'inherit',
        '--border-color': this.style.borderColor,
        '--accent-border-color': this.style.borderColor + 50
      }
    }
  },
  methods: {
    groupItems(isTumoral) {
      let items = {}
      this.logs.forEach(log => {
        if (
          log['pathology-diagnosis'] &&
          (isTumoral !== undefined
            ? log['pathology-diagnosis'].tumoral === isTumoral
            : true)
        ) {
          let group = log['pathology-diagnosis'].group
          let category = log['pathology-diagnosis'].category
          let type = log['pathology-diagnosis'].type
          let subtype = log['pathology-diagnosis'].subtype

          group = group ? group.replace(/[, ]+/g, '-').trim() : null
          category = category ? category.replace(/[, ]+/g, '-').trim() : null
          type = type ? type.replace(/[, ]+/g, '-').trim() : null
          subtype = subtype ? subtype.replace(/[, ]+/g, '-').trim() : null

          !items[group] && group
            ? (items[group] = {
                title: log['pathology-diagnosis'].group,
                children: {}
              })
            : ''
          !items[group].children[category] && category
            ? (items[group].children[category] = {
                title: log['pathology-diagnosis'].category,
                children: {}
              })
            : ''

          !items[group].children[category]?.children[type] && type
            ? (items[group].children[category].children[type] = {
                title: log['pathology-diagnosis'].type,
                children: {}
              })
            : ''
          !items[group].children[category]?.children[type]?.children[subtype] &&
          subtype
            ? (items[group].children[category].children[type].children[
                subtype
              ] = {
                title: log['pathology-diagnosis'].subtype
              })
            : ''
        }
      })
      return items
    },
    addAndCount(item, log, notLast) {
      if (!notLast) {
        if (!item.count) {
          item.count = 0
        }

        this.logbookType === 'histology' && !!log['quantidade']
          ? (item.count = item.count + Math.round(log['quantidade']))
          : (item.count = item.count + 1)
      }

      if (
        this.selectedRegion === 'Tecidos-Hematopoiéticos-e-Linfóides' &&
        log['pathology-diagnosis']?.hematologyOrgan &&
        item.count
      ) {
        if (!item.hematologyCounters) {
          item.hematologyCounters = {}
        }

        item.hematologyCounters = {
          ...item.hematologyCounters,
          [log['pathology-diagnosis'].hematologyOrgan]: item.hematologyCounters[
            log['pathology-diagnosis'].hematologyOrgan
          ]
            ? item.hematologyCounters[
                log['pathology-diagnosis'].hematologyOrgan
              ] + 1
            : 1
        }
      }

      if (
        item.items &&
        !item.items.some(
          item => item === log['pathology-diagnosis']['diagnosis']
        )
      ) {
        notLast ? '' : item.items.push(log['pathology-diagnosis']['diagnosis'])
      } else if (!item.items) {
        item.items = []
        notLast ? '' : item.items.push(log['pathology-diagnosis']['diagnosis'])
      }
      return item
    }
  },
  mounted() {
    this.$root.$emit('isTable', true)
    this.$root.$on('selectedStyle', style => {
      this.style = style
    })
  }
}
</script>

<style>
.styled-table {
  font-size: 0.9em;
  font-family: sans-serif;
  width: 100%;
  border-collapse: var(--border-collapse);
}
.styled-table td.text-center {
  text-align: center !important;
}
.styled-table.bordered td,
.styled-table.bordered thead {
  border-bottom: 1px solid var(--border-color);
}
.styled-table.bordered tr td,
.styled-table.bordered thead th {
  border-right: 1px solid var(--accent-border-color);
}
.styled-table.bordered tr td:last-child,
.styled-table.bordered thead th:last-child {
  border-right: none;
}
.categ-title {
  background-color: var(--categ-color) !important;
  width: 20px;
  font-weight: bold;
}
.subcateg-title {
  background-color: var(--subcateg-color) !important;
}
.rotate-text {
  writing-mode: vertical-lr;
  -ms-writing-mode: tb-rl;
  transform: rotate(180deg);
}
.combined-report thead th.header-title {
  background-color: var(--categ-color) !important;
}
.combined-report thead th.total {
  background-color: var(--bg-color) !important;
}
.styled-table th,
.styled-table td {
  padding: 12px 15px;
  text-align: center;
  vertical-align: middle;
}

.odd {
  background-color: var(--bg-odd-color);
}
.even {
  background-color: var(--bg-light-color);
}

tr.total td {
  background-color: var(--bg-odd-color);
}
tr.total td.odd {
  background-color: var(--subcateg-color);
}
.styled-table td.total {
  background-color: var(--subcateg-color);
  font-weight: bold;
  min-width: 70px;
}
.total-cell {
  background-color: var(--categ-color) !important;
  font-weight: bold;
}

.styled-table tr:last-of-type {
  border-bottom: 1px solid var(--border-color);
}
</style>
